module.exports = __webpack_public_path__ + "static/media/screenshare.6cf33cee.svg";